
import http from "../../../../../common/services/http";
import { defineComponent, ref, reactive, onMounted } from "vue";
import NgongVegBanner from "@/components/NgongVegBanner.vue";
import moment from "moment";

export default defineComponent({
    components: { NgongVegBanner },
    setup(props, ctx) {
        const search = ref("");
        const processing = ref(false);
        const created = ref(false);
        const updated = ref(false);
        const has_error = ref(false);
        const errors = ref();
        const headers = {
            name: "Name",
        };
        const records = ref({
            data: []
        });
        const record = reactive({
            name: "",
        });

        function searchRecords(event: any) {
            processing.value = true;
            http.get(`/api/brands?s=${search.value}`).then(res => {
                records.value = res.data;
                processing.value = false;
            });
        }

        function fetchRecords(page = 1) {
            processing.value = true;
            http.get(`/api/brands?page=${page}`).then(res => {
                records.value = res.data;
                processing.value = false;
            })
        }

        function createRecord() {
            http.post("api/brands", record).then(res => {
                if (res.data.success) {
                    created.value = true;

                    record.name = "";
                }
            }).finally(() => {
                document.getElementById("hideNewForm")?.click();
                fetchRecords();
            }).catch(error => {
                has_error.value = true;
                errors.value = error.response.data.errors;
            });
        }

        function updateRecord(record: any) {
            record._method = "PUT";
            http.post(`api/brands/${record.id}`, record).then(res => {
                if (res.data.success) {
                    updated.value = true;
                }
            }).finally(() => {
                // document.getElementById(`hideEditForm-${record.id}`)?.click();
                // fetchRecords();
                window.location.reload();
            });
        }

        function deleteRecord(id: any) {
            http.post(`/api/brands/${id}`, {_method: "DELETE"}).then(res => {
                fetchRecords();
            });
        }

        onMounted(() => {
            fetchRecords();
        });

        return {
            moment,
            search,
            processing,
            created,
            updated,
            has_error,
            errors,
            headers,
            records,
            record,
            searchRecords,
            fetchRecords,
            createRecord,
            updateRecord,
            deleteRecord,
        };
    },
});
